// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'everydaySansFont', 'everydaySansFont Fallback', Arial, sans-serif"},"className":"__className_b3751b"};